import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Users, Building2, Sparkles } from "lucide-react";
import { Logo } from "@/components/shared";

const HERO = "https://images.unsplash.com/photo-1759807966328-7379fadd1fd6?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="cs-shell grain overflow-hidden" style={{ background: "var(--cs-bg)" }}>
      <div className="relative">
        <div className="absolute inset-0">
          <img src={HERO} alt="Carnival masquerader" className="w-full h-full object-cover" style={{ height: 520 }} />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(11,11,14,0.35) 0%, rgba(11,11,14,0.75) 55%, #0B0B0E 100%)" }} />
        </div>

        <div className="relative px-6 pt-6" style={{ minHeight: 520 }}>
          <Logo size="md" />

          <motion.div
            initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15, duration: 0.6 }}
            className="mt-auto absolute bottom-8 left-6 right-6">
            <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 mb-4 text-xs font-semibold"
              style={{ background: "rgba(224,26,79,0.15)", color: "var(--cs-magenta-hi)", border: "1px solid rgba(224,26,79,0.4)" }}>
              <Sparkles size={13} /> The Safety Infrastructure Behind Carnival
            </div>
            <h1 className="font-head font-extrabold tracking-tight leading-[1.05] text-4xl sm:text-5xl">
              Carnival is freedom.<br />
              <span style={{ color: "var(--cs-magenta)" }}>Safety helps keep it that way.</span>
            </h1>
            <p className="mt-4 text-base" style={{ color: "var(--cs-fg2)" }}>
              The safety infrastructure for masqueraders, bands and trusted partners.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="px-6 pb-10 -mt-2">
        <button
          data-testid="landing-get-started-button"
          onClick={() => nav("/join")}
          className="cs-tap w-full magenta-grad magenta-glow rounded-2xl text-white font-head font-bold text-lg flex items-center justify-center gap-2"
          style={{ height: 60 }}>
          GET STARTED <ArrowRight size={20} />
        </button>
        <button
          data-testid="landing-login-button"
          onClick={() => nav("/login")}
          className="cs-tap w-full mt-3 rounded-2xl font-semibold text-base"
          style={{ height: 56, background: "var(--cs-card)", border: "1px solid var(--cs-border)", color: "#fff" }}>
          I ALREADY HAVE AN ACCOUNT
        </button>

        <div className="grid grid-cols-3 gap-3 mt-8">
          {[
            { icon: Users, label: "FOR MASQUERADERS", to: "/join" },
            { icon: Building2, label: "FOR BANDS", to: "/login" },
            { icon: Sparkles, label: "FOR BRANDS", to: "/login" },
          ].map((c) => (
            <button key={c.label} data-testid={`landing-audience-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => nav(c.to)}
              className="cs-card cs-tap flex flex-col items-center gap-2 py-4 px-2 text-center">
              <c.icon size={22} style={{ color: "var(--cs-magenta)" }} />
              <span className="text-[10px] font-bold tracking-wide" style={{ color: "var(--cs-fg2)" }}>{c.label}</span>
            </button>
          ))}
        </div>

        <p className="text-center text-xs mt-8" style={{ color: "#52525b" }}>
          Safer People. Brighter Carnival.
        </p>
      </div>
    </div>
  );
}
